import { USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE } from '@confluence/comments-data-manager/entry-points/useCommentById.ts';

// Setting ignoreNoNetworkError to true in the context allows GQL mutation
// to throw NoNetworkError from the Promise, so we can catch it and show
// a proper error message to the user. See COMMENTS-6859 for details.
export const buildMutationContextForNoNetworkError = (): {
	context: {
		fetchOptions: {
			ignoreNoNetworkError: boolean;
		};
	};
} => {
	return {
		context: {
			fetchOptions: {
				ignoreNoNetworkError: true,
			},
		},
	};
};

export const isCommentNotFoundError = (errorMessage?: string): boolean => {
	if (errorMessage) {
		// Check if the full error message matches the string thrown from useCommentById
		if (errorMessage === USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE) {
			return true;
		}
		// Also check the reason message (extracted from backend error format)
		const reasonStartIdx = errorMessage.lastIndexOf(':') + 1;
		const reasonMessage = errorMessage.substring(reasonStartIdx, errorMessage.length).trim();
		// If this string is ever updated on the BE and you need to change it - make sure to also update USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE for consistency
		const backendReasonMessage = 'No comment found for the given id';
		return reasonMessage === backendReasonMessage;
	}
	return false;
};
